/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

(() => {
  const ProductDescription = () => {
    document.querySelectorAll('.ProductMeta__Description').forEach(($description) => {
      let $list = $description.querySelector('ul')
      let $heading = $list.closest('.Rte').querySelector('h4');
      $list.classList.add('u-visually-hidden');
      if ($heading) {
        $heading.classList.add('u-visually-hidden');
      }

      $list.insertAdjacentHTML('afterend', `
        <div class="Collapsible">
          <button class="Collapsible__Button Heading u-h4" data-action="toggle-collapsible" aria-expanded="false">
            ${ $heading ? $heading.innerHTML : 'Description'} <span class="Collapsible__Plus"></span>
          </button>

          <div class="Collapsible__Inner">
            <div class="Collapsible__Content">
              <div class="Rte">
                ${ $list.innerHTML }
              </div>
            </div>
          </div>
        </div>      
      `);      

      // insert all other elements
      $description.querySelectorAll('.Collapsible ~ *').forEach(($item) => {
        $description.querySelector('.Collapsible .Rte').insertAdjacentElement('beforeend', $item);
      });

      $description.classList.add('initialized');
    });
  }

  const DOMReady = () => {
    ProductDescription();
  }

  document.addEventListener('DOMContentLoaded', DOMReady);
})();